import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchPhotoshootResult } from '@/services/photoshoot';
import type { PhotoshootDetail } from '@/types/photoshoot';

/** Как часто спрашиваем, продвинулась ли серия: кадры доделывает плановый воркер. */
export const PHOTOSHOOT_POLL_INTERVAL_MS = 4000;

/**
 * Пока серия идёт — опрашиваем; как только она завершена, перестаём сами.
 *
 * Серии нет (чужая и несуществующая неотличимы — RLS) или она ещё не
 * загрузилась — тоже не опрашиваем: ждать там нечего, а идущий вхолостую
 * запрос каждые несколько секунд был бы шумом для базы.
 */
export function photoshootRefetchInterval(
  data: PhotoshootDetail | null | undefined,
): number | false {
  return data && data.status !== 'completed' ? PHOTOSHOOT_POLL_INTERVAL_MS : false;
}

export function usePhotoshootResultQuery(photoshootId: string) {
  const { status } = useAuthSession();

  return useQuery({
    queryKey: ['photoshoot', photoshootId],
    queryFn: () => fetchPhotoshootResult(photoshootId),
    enabled: status === 'ready',
    refetchInterval: (query) => photoshootRefetchInterval(query.state.data),
  });
}
